import type { Place } from '../../types/place';

export const SET_MAIN_PLACE = 'SET_MAIN_PLACE' as const;
export const SET_CURRENT_PLACE = 'SET_CURRENT_PLACE' as const;
export const SET_CHILDREN = 'SET_CHILDREN' as const;
export const SET_HEADERS = 'SET_HEADERS' as const;
export const SET_LAYOUT = 'SET_LAYOUT' as const;

export const setMainPlace = (mainPlace: Place) => ({
    type: SET_MAIN_PLACE,
    payload: mainPlace
});

interface CurrentPlacePayload {
    currPlace?: number | string;
    children_list?: (number | string)[];
    parentId?: number | string;
    title?: string;
    subtitle?: string;
}

export const setCurrentPlace = (placeInfo: CurrentPlacePayload) => ({
    type: SET_CURRENT_PLACE,
    payload: placeInfo
});

export const setChildren = (childIds: (number | string)[]) => ({
    type: SET_CHILDREN,
    payload: childIds
});

interface HeadersPayload {
    title: string;
    subtitle: string;
}

export const setHeaders = (headers: HeadersPayload) => ({
    type: SET_HEADERS,
    payload: headers
});

export const setLayout = (layout: string) => ({
    type: SET_LAYOUT,
    payload: layout
});

export type TreeLevelAction =
    | ReturnType<typeof setMainPlace>
    | ReturnType<typeof setCurrentPlace>
    | ReturnType<typeof setChildren>
    | ReturnType<typeof setHeaders>
    | ReturnType<typeof setLayout>;
